(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["foilux-custom-print-personalisation"] && !Shopify.designMode) return;
  try {
    (function () {
    // Cheap exit on every page except CUSTOMPRINT_PER-tagged products - this
    // marker only renders when the product tag matches, in the Liquid above.
    if (!document.querySelector('[data-foilux-custom-print-personalisation]')) return;

    var CONTAINER_SELECTOR = '#infiniteoptions-container';

    // Every query below goes through this single container reference
    // (rather than re-running "#infiniteoptions-container X" compound
    // selectors against the whole document each time) so every read in a
    // given pass is guaranteed to come from the same, single container
    // element.
    function getContainer() {
      return document.querySelector(CONTAINER_SELECTOR);
    }

    // Finds the primary text field, its font radios, the "2nd line?" yes/no
    // radios, and the secondary text field by TYPE and ORDER among the
    // personalisation fields - never by name/id/label, which Infinite
    // Options derives from the field's title (see the big comment at the
    // top of this file for why that broke before). Field wrappers are
    // Infinite Options' own .foilux-personalisation(-start/-full) divs,
    // scoped to direct children of .foilux-personalisation-grid so upload/
    // gifting/social fields elsewhere in the container are never considered.
    function findPersonalisationFields(container) {
      var wrappers = container.querySelectorAll(
        '.foilux-personalisation-grid > :is(.foilux-personalisation, .foilux-personalisation-start, .foilux-personalisation-full)'
      );

      var textInputs = [];
      var textInputWrappers = [];
      var radioGroups = [];
      var radioGroupWrappers = [];

      wrappers.forEach(function (wrapper) {
        var textInput = wrapper.querySelector('input[type="text"]');
        if (textInput) {
          textInputs.push(textInput);
          textInputWrappers.push(wrapper);
        }

        var radios = wrapper.querySelectorAll('input[type="radio"]');
        if (radios.length >= 2) {
          radioGroups.push(radios);
          radioGroupWrappers.push(wrapper);
        }
      });

      return {
        primaryInput: textInputs[0] || null,
        primaryInputWrapper: textInputWrappers[0] || null,
        fontRadios: radioGroups[0] || null,
        fontRadiosWrapper: radioGroupWrappers[0] || null,
        additionalTextRadios: radioGroups[1] || null,
        additionalTextRadiosWrapper: radioGroupWrappers[1] || null,
        secondaryInput: textInputs[1] || null,
        secondaryInputWrapper: textInputWrappers[1] || null
      };
    }

    // NodeList has no .find() - plain loop instead of Array-prototype
    // gymnastics.
    function findChecked(radios) {
      if (!radios) return null;

      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return radios[i];
      }

      return null;
    }

    // Font 4 = Bacalisties - present in both maps below. If a fifth font is
    // ever added, it needs an entry here, a .foilux-cp-font--N /
    // .foilux-cp-font-label--N pair in the CSS above, and an @font-face rule.
    var FONT_FAMILY_CLASS_MAP = {
      'Font 1': 'foilux-cp-font--1',
      'Font 2': 'foilux-cp-font--2',
      'Font 3': 'foilux-cp-font--3',
      'Font 4': 'foilux-cp-font--4'
    };
    var FONT_LABEL_CLASS_MAP = {
      'Font 1': 'foilux-cp-font-label--1',
      'Font 2': 'foilux-cp-font-label--2',
      'Font 3': 'foilux-cp-font-label--3',
      'Font 4': 'foilux-cp-font-label--4'
    };
    var ALL_FONT_CLASSES = ['foilux-cp-font--1', 'foilux-cp-font--2', 'foilux-cp-font--3', 'foilux-cp-font--4'];
    var PRIMARY_PREVIEW_MIN_FONT_SIZE = 14; // px floor so long text never becomes unreadable

    // Infinite Options sometimes pads radio values with stray whitespace
    // (seen as "Font 1 " on this exact product) - trim before mapping so
    // that quirk can't silently break the font match.
    function setFontClass(el, radioValue) {
      if (!el) return;

      ALL_FONT_CLASSES.forEach(function (cls) { el.classList.remove(cls); });

      var key = radioValue && radioValue.trim();
      var cls = key && FONT_FAMILY_CLASS_MAP[key];
      if (cls) el.classList.add(cls);
    }

    function applySelectedFont() {
      var container = getContainer();
      if (!container) return;

      var fields = findPersonalisationFields(container);
      var previewPrimary = document.querySelector('[data-foilux-cp-preview-primary]');
      var checked = findChecked(fields.fontRadios);
      var value = checked ? checked.value : '';

      setFontClass(fields.primaryInput, value);
      setFontClass(previewPrimary, value);
      fitPrimaryPreviewText();
    }

    // Keeps the primary preview line on one row regardless of character
    // count: resets to the CSS-defined size for the current breakpoint,
    // measures how much wider the text wants to be than the box actually
    // is, and scales the font-size down by that ratio. Never scales above
    // the CSS-defined size, only down, and never below the readability
    // floor.
    function fitPrimaryPreviewText() {
      var el = document.querySelector('[data-foilux-cp-preview-primary]');
      if (!el || el.classList.contains('is-empty')) return;

      el.style.fontSize = '';
      var naturalSize = parseFloat(window.getComputedStyle(el).fontSize);
      if (!naturalSize) return;

      var available = el.clientWidth;
      var needed = el.scrollWidth;
      if (available <= 0 || needed <= available) return;

      var scale = available / needed;
      var newSize = Math.max(PRIMARY_PREVIEW_MIN_FONT_SIZE, Math.floor(naturalSize * scale * 0.97));
      el.style.fontSize = newSize + 'px';
    }

    // The secondary preview line only shows once "Additional Text" is
    // answered Yes AND text has actually been entered - if the customer
    // types text then switches back to No (Infinite Options doesn't
    // necessarily clear the field itself on toggle), the preview still
    // correctly hides it rather than showing text they said they didn't
    // want.
    function syncPreviewText() {
      var container = getContainer();
      if (!container) return;

      var fields = findPersonalisationFields(container);
      var additionalTextChecked = findChecked(fields.additionalTextRadios);
      var wantsSecondLine = !!additionalTextChecked && additionalTextChecked.value.trim() === 'Yes';
      var previewPrimary = document.querySelector('[data-foilux-cp-preview-primary]');
      var previewSecondary = document.querySelector('[data-foilux-cp-preview-secondary]');

      if (previewPrimary) {
        var primaryText = fields.primaryInput ? fields.primaryInput.value : '';
        previewPrimary.textContent = primaryText;
        previewPrimary.classList.toggle('is-empty', primaryText.trim() === '');
        fitPrimaryPreviewText();
      }

      if (previewSecondary) {
        var secondaryText = fields.secondaryInput ? fields.secondaryInput.value : '';
        previewSecondary.textContent = secondaryText;
        previewSecondary.classList.toggle('is-empty', !wantsSecondLine || secondaryText.trim() === '');
      }
    }

    // Builds the panel element itself - does not insert it anywhere. Called
    // at most once per page; ensurePreviewPanelPosition() below reuses the
    // same node forever after, so there's never a second one created.
    function createPreviewPanel() {
      var panel = document.createElement('div');
      panel.className = 'foilux-cp-preview';
      panel.setAttribute('data-foilux-cp-preview', '');
      panel.setAttribute('aria-hidden', 'true');

      var label = document.createElement('p');
      label.className = 'foilux-cp-preview__label';
      label.textContent = 'Live Preview';

      var primary = document.createElement('p');
      primary.className = 'foilux-cp-preview__primary is-empty';
      primary.setAttribute('data-foilux-cp-preview-primary', '');

      var secondary = document.createElement('p');
      secondary.className = 'foilux-cp-preview__secondary is-empty';
      secondary.setAttribute('data-foilux-cp-preview-secondary', '');

      var note = document.createElement('p');
      note.className = 'foilux-cp-preview__note';
      note.textContent = 'Preview shown for font and text layout guidance.';

      panel.appendChild(label);
      panel.appendChild(primary);
      panel.appendChild(secondary);
      panel.appendChild(note);

      return panel;
    }

    // Purely decorative mirror of the two real inputs - aria-hidden because
    // the actual, authoritative fields (with their own labels) are right
    // above it; textContent only, never innerHTML, so typed text can't be
    // interpreted as markup.
    //
    // Unlike a one-time "build if missing" check, this runs every tryWire()
    // pass and actively verifies the panel is STILL positioned right after
    // the current Main Heading Font field wrapper, not just that a panel
    // exists somewhere. That's the actual fix for the preview landing in
    // the wrong place: Infinite Options can rebuild its fields later (its
    // own reactive re-render), which can leave a previously-correct panel
    // orphaned relative to the fields' new position - a single "does it
    // exist" check would never notice that and never move it back. The
    // existing panel node is always reused (never re-created), so this
    // can't produce duplicates, and insertBefore is skipped entirely when
    // the panel is already exactly where it belongs, so a correctly-placed
    // panel causes no extra DOM mutation on repeat passes.
    //
    // Returns true only when the panel was freshly created this call (not
    // merely repositioned), since a repositioned node keeps its existing
    // text/classes and doesn't need a resync.
    function ensurePreviewPanelPosition(headingFontField) {
      if (!headingFontField || !headingFontField.parentNode) return false;

      var panel = document.querySelector('[data-foilux-cp-preview]');
      var isNew = !panel;

      if (isNew) {
        panel = createPreviewPanel();
      }

      if (panel.previousElementSibling !== headingFontField || panel.parentNode !== headingFontField.parentNode) {
        headingFontField.parentNode.insertBefore(panel, headingFontField.nextSibling);
      }

      return isNew;
    }

    // Wires the primary field + its font radios once found and returns
    // true; returns false (and changes nothing) if either isn't in the DOM
    // yet, so the caller knows to keep waiting. The secondary field is
    // wired opportunistically at the same time if present - in practice
    // Infinite Options renders its whole field set in one batch, so it's
    // there whenever the primary field is.
    //
    // Only resyncs the preview text/font when something was genuinely new
    // this pass (an element just got wired, or the panel just got rebuilt)
    // - never unconditionally. syncPreviewText() writes textContent, which
    // is itself a childList mutation our own observer is watching for; an
    // unconditional call here would mean every keystroke's direct
    // syncPreviewText() call re-triggers tryWire() via the observer, which
    // would call syncPreviewText() again, re-triggering the observer again,
    // forever. Gating on "did anything actually change" breaks that loop -
    // steady-state passes just read the DOM and return.
    function tryWire() {
      var container = getContainer();
      if (!container) return false;

      var fields = findPersonalisationFields(container);
      var input = fields.primaryInput;
      var radios = fields.fontRadios;

      if (!input || !radios || !radios.length) return false;

      var somethingIsNew = false;

      // Marker classes for the CSS - structural identification (see
      // findPersonalisationFields()), not field name/title. classList.add()
      // on an already-present class is a harmless no-op and, unlike
      // textContent writes, isn't a childList mutation our own observer
      // below reacts to, so it's safe to re-apply on every pass.
      input.classList.add('foilux-cp-primary-input');
      if (fields.primaryInputWrapper) fields.primaryInputWrapper.classList.add('foilux-cp-full-width-field');
      if (fields.fontRadiosWrapper) fields.fontRadiosWrapper.classList.add('foilux-cp-full-width-field');
      if (fields.additionalTextRadiosWrapper) fields.additionalTextRadiosWrapper.classList.add('foilux-cp-full-width-field');
      if (fields.secondaryInput) fields.secondaryInput.classList.add('foilux-cp-secondary-input');
      if (fields.secondaryInputWrapper) fields.secondaryInputWrapper.classList.add('foilux-cp-full-width-field');

      radios.forEach(function (radio) {
        if (radio.dataset.foiluxCpWired === 'true') return;
        somethingIsNew = true;

        radio.addEventListener('change', applySelectedFont);
        radio.dataset.foiluxCpWired = 'true';

        var label = radio.closest('label');
        var key = radio.value && radio.value.trim();
        var labelClass = key && FONT_LABEL_CLASS_MAP[key];
        if (label && labelClass) label.classList.add(labelClass);

        var optionsWrap = label && label.parentElement;
        if (optionsWrap) optionsWrap.classList.add('foilux-cp-font-options');
      });

      if (input.dataset.foiluxCpWired !== 'true') {
        somethingIsNew = true;
        input.addEventListener('input', syncPreviewText);
        input.dataset.foiluxCpWired = 'true';
      }

      if (fields.secondaryInput && fields.secondaryInput.dataset.foiluxCpWired !== 'true') {
        somethingIsNew = true;
        fields.secondaryInput.addEventListener('input', syncPreviewText);
        fields.secondaryInput.dataset.foiluxCpWired = 'true';
      }

      // Wired so switching Yes/No immediately shows/hides the secondary
      // preview line even before any text is typed or edited.
      if (fields.additionalTextRadios) {
        fields.additionalTextRadios.forEach(function (radio) {
          if (radio.dataset.foiluxCpWired === 'true') return;
          somethingIsNew = true;

          radio.addEventListener('change', syncPreviewText);
          radio.dataset.foiluxCpWired = 'true';
        });
      }

      // Anchored strictly to the CURRENT font-choice field wrapper - no
      // fallback chain, and re-verified/repositioned on every pass (not
      // just built once) so a later Infinite Options re-render can't leave
      // it stranded in a stale position. If that field genuinely isn't
      // there yet, this just no-ops and the observer tries again on the
      // next mutation.
      var panelIsNew = ensurePreviewPanelPosition(fields.fontRadiosWrapper);
      somethingIsNew = somethingIsNew || panelIsNew;

      if (somethingIsNew) {
        applySelectedFont();
        syncPreviewText();
      }

      return true;
    }

    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitPrimaryPreviewText, 120);
    }

    try {
      // Infinite Options renders its fields asynchronously after an AJAX
      // fetch, so they're very unlikely to exist yet on first run. It also
      // re-renders #infiniteoptions-container's contents reactively after
      // that (observed when conditional field visibility re-evaluates),
      // which would silently destroy the preview panel and its listeners -
      // so unlike a one-shot init, this observer is deliberately never
      // disconnected. tryWire() is cheap and idempotent per element (the
      // foiluxCpWired dataset flag) and per panel (the
      // [data-foilux-cp-preview] guard), so repeated calls for the page's
      // lifetime just no-op once everything is already wired - matching
      // the pattern foilux-personalisation.liquid itself already uses.
      tryWire();

      var observer = new MutationObserver(tryWire);
      observer.observe(document.body, { childList: true, subtree: true });

      window.addEventListener('resize', onResize);

      if (window.document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fitPrimaryPreviewText);
      }
    } catch (error) {
      /* Fails safe: native Infinite Options fields remain fully usable. */
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foilux-fp-personalise"] && !Shopify.designMode) return;
  try {
    (function () {
    var triggerTemplate = document.querySelector('[data-fp-trigger-template]');

    // No-op on any page/product that doesn't render the trigger template
    // (i.e. anything not tagged FP) - cheap exit, no observer set up at all.
    if (!triggerTemplate) return;

    var UPLOADERY_SKIP = 'skip';
    var panelInner = null;
    var panelEl = null;
    var trigger = null;
    var triggerLabel = null;
    var triggerWrap = null;
    var built = false;

    // The real Foil Colour variant option, identified by the option name
    // Shopify itself embeds in the field's `name` attribute - not by
    // scraping rendered label text, which would break if the markup or
    // wording around it ever changes. Covers both the button/swatch style
    // (`name="Foil Colour-..."`) and the dropdown style
    // (`name="options[Foil Colour]"`), since either can be configured.
    // Matched case-insensitively, since CSS attribute selectors are exact-case
    // and the option's capitalisation as typed in Shopify admin isn't guaranteed.
    function findFoilColourOption() {
      var options = document.querySelectorAll('.variant-option');

      for (var i = 0; i < options.length; i++) {
        var fields = options[i].querySelectorAll('input[name], select[name]');

        for (var j = 0; j < fields.length; j++) {
          var name = fields[j].getAttribute('name') || '';

          if (/^foil colour-/i.test(name) || /^options\[foil colour\]$/i.test(name)) {
            return options[i];
          }
        }
      }

      return null;
    }

    function buildPanel() {
      if (built) return true;

      var personalisationPanel = document.querySelector('.foilux-personalisation-panel');
      var addToCartButton = document.querySelector('form[action="/cart/add"] button[name="add"]');
      var foilColourOption = findFoilColourOption();

      if (!personalisationPanel || !addToCartButton || !foilColourOption) return false;

      // Out of scope for this build - leave Uploadery products completely untouched.
      if (personalisationPanel.querySelector('form[data-uploadery]')) return UPLOADERY_SKIP;

      var addToCartComponent = addToCartButton.closest('add-to-cart-component') || addToCartButton;
      if (!addToCartComponent.parentNode || !foilColourOption.parentNode) return false;

      // Trigger: inserted directly after the real Foil Colour variant option block.
      triggerWrap = triggerTemplate.content.firstElementChild.cloneNode(true);
      foilColourOption.parentNode.insertBefore(triggerWrap, foilColourOption.nextSibling);

      trigger = triggerWrap.querySelector('[data-fp-trigger]');
      triggerLabel = triggerWrap.querySelector('[data-fp-trigger-label]');
      trigger.addEventListener('click', expand);

      // Panel: built and inserted at the real Add to Cart button's original
      // position, inside the real product form - preserves native form
      // association and keeps the button matching
      // `form[action="/cart/add"] button[name="add"]` for both Infinite
      // Options' own validation and foilux-required-field-highlight.liquid.
      panelEl = document.createElement('div');
      panelEl.className = 'fp-personalise-panel';
      panelEl.setAttribute('data-fp-panel', '');
      panelEl.inert = true;

      panelInner = document.createElement('div');
      panelInner.className = 'fp-personalise-panel__inner';
      panelEl.appendChild(panelInner);

      addToCartComponent.parentNode.insertBefore(panelEl, addToCartComponent);

      panelInner.appendChild(personalisationPanel);
      panelInner.appendChild(addToCartComponent);

      built = true;
      return true;
    }

    // Infinite Options loads its fields asynchronously and not necessarily all
    // at once, so gifting/social permissions may not exist yet when the panel
    // is first built. This keeps sweeping them in, in the correct position
    // (before the real Add to Cart button), whenever they do appear.
    function sweepLateFields() {
      if (!panelInner) return;

      var addToCartAnchor = panelInner.querySelector('add-to-cart-component')
        || panelInner.querySelector('form[action="/cart/add"] button[name="add"]');

      ['.foilux-gifting-options', '.foilux-social-permissions'].forEach(function (selector) {
        var field = document.querySelector(selector);
        if (!field || panelInner.contains(field)) return;

        if (addToCartAnchor) {
          panelInner.insertBefore(field, addToCartAnchor);
        } else {
          panelInner.appendChild(field);
        }
      });
    }

    function tick() {
      var result = buildPanel();
      if (result === UPLOADERY_SKIP) return true;

      sweepLateFields();
      return false;
    }

    function expand() {
      if (!panelEl) return;

      panelEl.inert = false;

      requestAnimationFrame(function () {
        panelEl.classList.add('fp-personalise-panel--open');
      });

      trigger.setAttribute('aria-expanded', 'true');
      if (triggerLabel) triggerLabel.textContent = 'Personalising…';
      trigger.disabled = true;

      var firstField = panelEl.querySelector('input, select, textarea, [tabindex]');
      if (firstField) {
        var rect = firstField.getBoundingClientRect();
        var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!inView) {
          firstField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      setTimeout(function () {
        triggerWrap.hidden = true;
      }, 250);
    }

    if (tick()) return;

    try {
      var observer = new MutationObserver(function () {
        if (tick()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      /* Fails safe: genuine Add to Cart button remains visible/usable if the panel can't be built. */
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foilux-gifting-options"] && !Shopify.designMode) return;
  try {
    (function () {
    function splitSwatchLabel(labelEl, showFallbackPrice) {
      if (labelEl.dataset.foiluxSplit === 'true') return;

      var raw = labelEl.textContent.trim();
      var match = raw.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
      var title = match ? match[1].trim() : raw;
      var priceText = match ? match[2].trim() : (showFallbackPrice ? 'Included' : '');

      var titleSpan = document.createElement('span');
      titleSpan.className = 'foilux-card-title';
      titleSpan.textContent = title;

      labelEl.textContent = '';
      labelEl.appendChild(titleSpan);

      if (priceText) {
        var priceSpan = document.createElement('span');
        priceSpan.className = 'foilux-card-price';
        priceSpan.textContent = priceText;
        labelEl.appendChild(document.createTextNode(' '));
        labelEl.appendChild(priceSpan);
      }

      labelEl.dataset.foiluxSplit = 'true';
    }

    function injectHeading(container, subtitle) {
      if (container.querySelector('.foilux-gifting-heading')) return;

      var heading = document.createElement('div');
      heading.className = 'foilux-gifting-heading';
      heading.setAttribute('aria-hidden', 'true');
      heading.innerHTML =
        '<h3 class="foilux-gifting-title">Complete the gift</h3>' +
        '<p class="foilux-gifting-subtitle">' + subtitle + '</p>';

      container.insertBefore(heading, container.firstChild);
    }

    function enhance(container, subtitle, showFallbackPrice) {
      try {
        injectHeading(container, subtitle);

        var labels = container.querySelectorAll('.spb-swatchlabel');
        for (var i = 0; i < labels.length; i++) {
          splitSwatchLabel(labels[i], showFallbackPrice);
        }
      } catch (error) {
        /* Fails safe: native Infinite Options field remains fully usable. */
      }
    }

    function tryEnhance() {
      var giftbox = document.querySelector('.foilux-gifting-options');
      if (giftbox) enhance(giftbox, 'How would you like your ticket to be presented?', true);

      var giftboxPrints = document.querySelector('.INF_GIFTBOXPRINTS');
      if (giftboxPrints) enhance(giftboxPrints, 'How would you like your print to be presented?', false);
    }

    try {
      var observer = new MutationObserver(tryEnhance);
      observer.observe(document.body, { childList: true, subtree: true });
      tryEnhance();
    } catch (error) {
      /* Fails safe: native Infinite Options field remains fully usable. */
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foilux-personalisation"] && !Shopify.designMode) return;
  try {
    (function () {
    var MEMBER_CLASSES = ['foilux-personalisation', 'foilux-personalisation-start', 'foilux-personalisation-full'];

    function fieldsPresent() {
      return !!document.querySelector(
        '.foilux-personalisation, .foilux-personalisation-start, .foilux-personalisation-full, form[data-uploadery]'
      );
    }

    function removeSkeleton() {
      var skeleton = document.querySelector('.foilux-personalisation-skeleton');
      if (skeleton) skeleton.remove();
    }

    function insertSkeleton() {
      if (fieldsPresent() || document.querySelector('.foilux-personalisation-skeleton')) return;

      var addToCartButton = document.querySelector('form[action="/cart/add"] button[name="add"]');
      if (!addToCartButton) return;

      var anchor = addToCartButton.closest('form[action="/cart/add"]') || addToCartButton;
      if (!anchor.parentNode) return;

      var skeleton = document.createElement('div');
      skeleton.className = 'foilux-personalisation-skeleton';
      skeleton.setAttribute('aria-hidden', 'true');

      anchor.parentNode.insertBefore(skeleton, anchor);
    }

    try {
      insertSkeleton();
    } catch (error) {
      /* Fails safe: purely cosmetic, real fields still render regardless. */
    }

    // Uploadery's field is <div><span><form data-uploadery>...</form></span></div> -
    // the classifying/moving unit must be the outer div (same level as the other
    // personalisation fields), not the form buried inside it, or the sibling walk
    // below would stop dead the moment it reached this field.
    function findUploadCard(form) {
      return (form.closest && form.closest('div')) || form;
    }

    function isUploadCard(el) {
      return !!(el.querySelector && el.querySelector('form[data-uploadery]'));
    }

    function isMember(el) {
      if (isUploadCard(el)) return true;

      return MEMBER_CLASSES.some(function (name) {
        return el.classList.contains(name);
      });
    }

    function classifyField(el) {
      el.classList.remove('foilux-personalisation-span');

      if (
        el.classList.contains('foilux-personalisation-start') ||
        el.classList.contains('foilux-personalisation-full') ||
        isUploadCard(el)
      ) {
        el.classList.add('foilux-personalisation-span');
        return;
      }

      if (el.querySelector('textarea') || el.querySelector('fieldset')) {
        el.classList.add('foilux-personalisation-span');
      }
    }

    function addUploadHint(el) {
      if (!isUploadCard(el) || el.dataset.foiluxHintAdded === 'true') return;

      var label = el.querySelector('form[data-uploadery] label');
      if (!label) return;

      var hint = document.createElement('span');
      hint.className = 'foilux-upload-hint';
      hint.textContent = 'JPG, PNG or HEIC';
      label.appendChild(hint);

      el.dataset.foiluxHintAdded = 'true';
    }

    // Uploadery marks its own form data-uploadery-valid="false"/"true" - this
    // watches that attribute rather than the file input's change event, since
    // change only fires on local selection, before the file has actually
    // finished uploading and been validated.
    function addUploadCompleteIndicator(el) {
      var form = el.querySelector && el.querySelector('form[data-uploadery]');
      if (!form || form.dataset.foiluxCompleteAdded === 'true') return;

      var fileupload = form.querySelector('.spb-fileupload');
      if (!fileupload || !fileupload.parentNode) return;

      var row = document.createElement('div');
      row.className = 'foilux-upload-row';
      fileupload.parentNode.insertBefore(row, fileupload);
      row.appendChild(fileupload);

      var indicator = document.createElement('span');
      indicator.className = 'foilux-upload-complete';
      indicator.innerHTML = CHECK_ICON_SVG + '<span>Uploaded</span>';
      row.appendChild(indicator);

      var syncState = function () {
        indicator.classList.toggle('is-visible', form.getAttribute('data-uploadery-valid') === 'true');
      };

      syncState();

      var attrObserver = new MutationObserver(syncState);
      attrObserver.observe(form, { attributes: true, attributeFilter: ['data-uploadery-valid'] });

      form.dataset.foiluxCompleteAdded = 'true';
    }

    function softenOptionalText(el) {
      var label = el.querySelector('.spb-label-tooltip label');
      if (!label || label.dataset.foiluxOptionalSplit === 'true') return;

      var raw = label.textContent;
      var match = raw.match(/^(.*?)(\s*\(optional\)\s*)$/i);
      if (!match) return;

      label.textContent = '';
      label.appendChild(document.createTextNode(match[1]));

      var optionalSpan = document.createElement('span');
      optionalSpan.className = 'foilux-personalisation-label-optional';
      optionalSpan.textContent = match[2];
      label.appendChild(optionalSpan);

      label.dataset.foiluxOptionalSplit = 'true';
    }

    // Infinite Options renders single-choice fields (min=1/max=1) as plain
    // checkboxes rather than radios, so it rejects a second one being
    // checked while one is already checked instead of auto-swapping - the
    // customer has to manually uncheck first. This intercepts the label
    // click, unchecks the previously-selected checkbox via a genuine
    // .click() first, then checks the new one, so it always presents a
    // valid min=1/max=1 state to Infinite Options. Applies to any
    // checkbox-fieldset swept into this panel (e.g. Wording, or a
    // "we're/you're going on holiday" style field), not one specific field.
    function wireFieldsetSingleSelect(el) {
      var fieldset = el.querySelector && el.querySelector('fieldset');
      if (!fieldset || fieldset.dataset.foiluxSingleSelectWired === 'true') return;

      var checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
      if (checkboxes.length < 2) return;

      var suppress = false;

      checkboxes.forEach(function (checkbox) {
        var label = checkbox.closest('label');
        if (!label) return;

        // A checkbox's `checked` property is updated by the browser before
        // its click event even reaches this handler - so by the time this
        // fires, checkbox.checked is already the NEW value whether the
        // click landed on the checkbox itself or elsewhere in the label.
        // That made "was this already selected?" unreliable when clicking
        // the checkbox directly: the code below would treat "just selected"
        // the same as "already selected", skip the un-check-the-other-one
        // step, and Infinite Options' own min/max=1 rule would then reject
        // the new selection outright. `pointerdown` fires strictly before
        // any of that, so it reliably captures the true prior state.
        var wasChecked = checkbox.checked;
        label.addEventListener('pointerdown', function () {
          wasChecked = checkbox.checked;
        });

        label.addEventListener('click', function (event) {
          if (suppress) return;

          if (wasChecked) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          suppress = true;

          checkboxes.forEach(function (other) {
            if (other !== checkbox && other.checked) {
              other.click();
            }
          });

          checkbox.click();

          suppress = false;
        });
      });

      fieldset.dataset.foiluxSingleSelectWired = 'true';
    }

    function getMonogramUrl() {
      var script = document.querySelector('[data-foilux-personalisation-assets]');
      if (!script) return '';

      try {
        var data = JSON.parse(script.textContent);
        return data.monogramUrl || '';
      } catch (error) {
        return '';
      }
    }

    var CHECK_ICON_SVG =
      '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.2"/>' +
      '<path d="M6.2 10.3l2.4 2.4 5.2-5.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    function buildPanel() {
      var uploadForm = document.querySelector('form[data-uploadery]');
      var first = document.querySelector('.foilux-personalisation-start') ||
        document.querySelector('.foilux-personalisation-full') ||
        document.querySelector('.foilux-personalisation') ||
        (uploadForm ? findUploadCard(uploadForm) : null);

      if (!first || !first.parentNode) return;

      var panel = document.createElement('div');
      panel.className = 'foilux-personalisation-panel';

      var heading = document.createElement('div');
      heading.className = 'foilux-personalisation-heading';
      heading.innerHTML =
        '<h3 class="foilux-personalisation-eyebrow">Make it yours</h3>' +
        '<p class="foilux-personalisation-subtitle">Add your details below to make it truly personal.</p>';

      var grid = document.createElement('div');
      grid.className = 'foilux-personalisation-grid';

      first.parentNode.insertBefore(panel, first);
      panel.appendChild(heading);
      panel.appendChild(grid);

      var node = first;
      while (node && isMember(node)) {
        var next = node.nextElementSibling;
        grid.appendChild(node);
        classifyField(node);
        softenOptionalText(node);
        addUploadHint(node);
        addUploadCompleteIndicator(node);
        wireFieldsetSingleSelect(node);
        node = next;
      }
    }

    // The real Foil Colour variant option, identified by the option name
    // Shopify itself embeds in the field's `name` attribute - not by
    // scraping rendered label text, which would break if the markup or
    // wording around it ever changes. Covers both the button/swatch style
    // (`name="Foil Colour-..."`) and the dropdown style
    // (`name="options[Foil Colour]"`), matched case-insensitively since CSS
    // attribute selectors are exact-case and the option's capitalisation as
    // typed in Shopify admin isn't guaranteed.
    function findFoilColourOption() {
      var options = document.querySelectorAll('.variant-option');

      for (var i = 0; i < options.length; i++) {
        var fields = options[i].querySelectorAll('input[name], select[name]');

        for (var j = 0; j < fields.length; j++) {
          var name = fields[j].getAttribute('name') || '';

          if (/^foil colour-/i.test(name) || /^options\[foil colour\]$/i.test(name)) {
            return options[i];
          }
        }
      }

      return null;
    }

    function insertFoilColourDivider() {
      if (document.querySelector('.foilux-personalisation-divider')) return;

      var foilColourOption = findFoilColourOption();
      if (!foilColourOption || !foilColourOption.parentNode) return;

      var monogramUrl = getMonogramUrl();
      var divider = document.createElement('div');
      divider.className = 'foilux-personalisation-divider';
      divider.setAttribute('aria-hidden', 'true');
      divider.innerHTML =
        '<span class="foilux-personalisation-divider-line"></span>' +
        (monogramUrl
          ? '<img class="foilux-personalisation-divider-mark" src="' + monogramUrl + '" alt="" loading="lazy">'
          : '') +
        '<span class="foilux-personalisation-divider-line"></span>';

      foilColourOption.parentNode.insertBefore(divider, foilColourOption.nextSibling);
    }

    function collectStray(grid) {
      var fields = Array.prototype.slice.call(
        document.querySelectorAll('.foilux-personalisation, .foilux-personalisation-start, .foilux-personalisation-full')
      );

      Array.prototype.forEach.call(document.querySelectorAll('form[data-uploadery]'), function (form) {
        fields.push(findUploadCard(form));
      });

      fields.forEach(function (el) {
        if (!grid.contains(el)) {
          grid.appendChild(el);
          classifyField(el);
          softenOptionalText(el);
          addUploadHint(el);
          addUploadCompleteIndicator(el);
          wireFieldsetSingleSelect(el);
        }
      });
    }

    function tryEnhance() {
      try {
        insertFoilColourDivider();

        if (fieldsPresent()) removeSkeleton();

        var panel = document.querySelector('.foilux-personalisation-panel');

        if (panel) {
          var grid = panel.querySelector('.foilux-personalisation-grid');
          if (grid) collectStray(grid);
          return;
        }

        buildPanel();
      } catch (error) {
        /* Fails safe: native Infinite Options fields remain fully usable. */
      }
    }

    try {
      var observer = new MutationObserver(tryEnhance);
      observer.observe(document.body, { childList: true, subtree: true });
      tryEnhance();
    } catch (error) {
      /* Fails safe: native Infinite Options fields remain fully usable. */
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foilux-pet-portrait-font-preview"] && !Shopify.designMode) return;
  try {
    (function () {
    // Cheap exit on every page except the Pet Portrait product - this
    // marker only renders when product.handle matches, in the Liquid above.
    if (!document.querySelector('[data-foilux-pet-font-preview]')) return;

    var CONTAINER_SELECTOR = '#infiniteoptions-container';
    var NAME_INPUT_SELECTOR = 'input[name="properties[Pet\'s Name]"]';
    var FONT_RADIO_SELECTOR = 'input[name="properties[Font Option]"]';

    var FONT_INPUT_CLASS_MAP = {
      'Font 1': 'foilux-pet-font--1',
      'Font 2': 'foilux-pet-font--2',
      'Font 3': 'foilux-pet-font--3'
    };
    var FONT_LABEL_CLASS_MAP = {
      'Font 1': 'foilux-pet-font-label--1',
      'Font 2': 'foilux-pet-font-label--2',
      'Font 3': 'foilux-pet-font-label--3'
    };
    var ALL_INPUT_FONT_CLASSES = ['foilux-pet-font--1', 'foilux-pet-font--2', 'foilux-pet-font--3'];

    function applySelectedFont() {
      var input = document.querySelector(CONTAINER_SELECTOR + ' ' + NAME_INPUT_SELECTOR);
      if (!input) return;

      var checked = document.querySelector(CONTAINER_SELECTOR + ' ' + FONT_RADIO_SELECTOR + ':checked');

      ALL_INPUT_FONT_CLASSES.forEach(function (cls) { input.classList.remove(cls); });

      if (checked && FONT_INPUT_CLASS_MAP[checked.value]) {
        input.classList.add(FONT_INPUT_CLASS_MAP[checked.value]);
      }
    }

    // Wires the radios once found and returns true; returns false (and
    // changes nothing) if either the radios or the name input aren't in
    // the DOM yet, so the caller knows to keep waiting.
    function tryWire() {
      var radios = document.querySelectorAll(CONTAINER_SELECTOR + ' ' + FONT_RADIO_SELECTOR);
      var input = document.querySelector(CONTAINER_SELECTOR + ' ' + NAME_INPUT_SELECTOR);

      if (!radios.length || !input) return false;

      radios.forEach(function (radio) {
        if (radio.dataset.foiluxFontWired === 'true') return;

        radio.addEventListener('change', applySelectedFont);
        radio.dataset.foiluxFontWired = 'true';

        var label = radio.closest('label');
        var labelClass = FONT_LABEL_CLASS_MAP[radio.value];
        if (label && labelClass) label.classList.add(labelClass);

        var optionsWrap = label && label.parentElement;
        if (optionsWrap) optionsWrap.classList.add('foilux-pet-font-options');
      });

      applySelectedFont();
      return true;
    }

    try {
      // Infinite Options renders its fields asynchronously after an AJAX
      // fetch, so they're very unlikely to exist yet on first run - this
      // keeps checking via MutationObserver until they appear, then
      // disconnects. No polling interval, no reinitialising afterwards.
      if (tryWire()) return;

      var observer = new MutationObserver(function () {
        if (tryWire()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      /* Fails safe: native Infinite Options fields remain fully usable. */
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foilux-required-field-highlight"] && !Shopify.designMode) return;
  try {
    (function () {
    var CARD_SELECTOR =
      '.foilux-personalisation, .foilux-personalisation-start, .foilux-personalisation-full, ' +
      '.foilux-gifting-options, .INF_GIFTBOXPRINTS, .foilux-social-permissions';

    function findCard(field) {
      return (field.closest && field.closest(CARD_SELECTOR)) || field;
    }

    function clearHighlight(card) {
      card.classList.remove('foilux-field-missing');
      var message = card.querySelector('.foilux-field-missing-message');
      if (message) message.remove();
    }

    function highlight(card, text) {
      card.classList.add('foilux-field-missing');

      if (!card.querySelector('.foilux-field-missing-message')) {
        var message = document.createElement('p');
        message.className = 'foilux-field-missing-message';
        message.textContent = text;
        card.appendChild(message);
      }
    }

    function checkFields() {
      try {
        document.querySelectorAll('.foilux-field-missing').forEach(clearHighlight);

        var firstMissing = null;

        document.querySelectorAll('[required]').forEach(function (field) {
          if (typeof field.checkValidity === 'function' && !field.checkValidity()) {
            var card = findCard(field);
            highlight(card, 'This field is required.');
            if (!firstMissing) firstMissing = card;
          }
        });

        document.querySelectorAll('fieldset[data-required="true"]').forEach(function (fieldset) {
          if (!fieldset.querySelector('input:checked')) {
            var card = findCard(fieldset);
            highlight(card, 'Please select an option.');
            if (!firstMissing) firstMissing = card;
          }
        });

        if (firstMissing) {
          firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } catch (error) {
        /* Fails safe: Infinite Options' own validation/alert still runs regardless. */
      }
    }

    function watchField(field) {
      if (field.dataset.foiluxRequiredWatched === 'true') return;

      var clear = function () {
        if (typeof field.checkValidity !== 'function' || field.checkValidity()) {
          clearHighlight(findCard(field));
        }
      };

      field.addEventListener('input', clear);
      field.addEventListener('change', clear);
      field.dataset.foiluxRequiredWatched = 'true';
    }

    function watchFieldset(fieldset) {
      if (fieldset.dataset.foiluxRequiredWatched === 'true') return;

      fieldset.addEventListener('change', function () {
        if (fieldset.querySelector('input:checked')) {
          clearHighlight(findCard(fieldset));
        }
      });

      fieldset.dataset.foiluxRequiredWatched = 'true';
    }

    function attachWatchers() {
      try {
        document.querySelectorAll('[required]').forEach(watchField);
        document.querySelectorAll('fieldset[data-required="true"]').forEach(watchFieldset);
      } catch (error) {
        /* Fails safe. */
      }
    }

    try {
      document.addEventListener(
        'click',
        function (event) {
          var button = event.target.closest && event.target.closest('form[action="/cart/add"] button[name="add"]');
          if (!button) return;

          checkFields();
        },
        true
      );

      attachWatchers();

      var observer = new MutationObserver(attachWatchers);
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      /* Fails safe: Infinite Options' own validation/alert still runs regardless. */
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foilux-social-permissions"] && !Shopify.designMode) return;
  try {
    (function () {
    var HEART_SVG =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';

    function injectHeading(container) {
      if (container.querySelector('.foilux-social-heading')) return;

      var heading = document.createElement('p');
      heading.className = 'foilux-social-heading';
      heading.innerHTML = '<span class="foilux-social-heading-text">Social Media Permissions</span>';
      container.insertBefore(heading, container.firstChild);
    }

    function enhance(container) {
      injectHeading(container);

      var checkboxes = container.querySelectorAll('fieldset input[type="checkbox"]');

      // Infinite Options is configured with minimum/maximum selection = 1,
      // so it rejects a second checkbox becoming checked while one is
      // already checked, rather than auto-swapping. This means the order
      // matters: the previously-checked box must be unchecked first, then
      // the new one checked - never both checked at once. `suppress`
      // prevents the .click() calls this code makes on the other real
      // checkboxes from re-triggering this same handler recursively.
      var suppress = false;

      checkboxes.forEach(function (checkbox) {
        if (checkbox.dataset.foiluxHeartAdded === 'true') return;

        var heart = document.createElement('span');
        heart.className = 'foilux-heart';
        heart.setAttribute('aria-hidden', 'true');
        heart.innerHTML = HEART_SVG;
        checkbox.insertAdjacentElement('afterend', heart);

        var label = checkbox.closest('label');

        if (label) {
          // A checkbox's `checked` property is updated by the browser
          // before its click event reaches this handler - so by the time
          // this fires, checkbox.checked is already the NEW value whether
          // the click landed on the checkbox itself or elsewhere in the
          // label. That made "was this already selected?" unreliable when
          // clicking the checkbox directly: the code below would treat
          // "just selected" the same as "already selected", skip the
          // un-check-the-other-one step, and Infinite Options' own
          // min/max=1 rule would then reject the new selection outright.
          // `pointerdown` fires strictly before any of that, so it reliably
          // captures the true prior state.
          var wasChecked = checkbox.checked;
          label.addEventListener('pointerdown', function () {
            wasChecked = checkbox.checked;
          });

          label.addEventListener('click', function (event) {
            if (suppress) return;

            if (wasChecked) {
              // Already the selected option - clicking it again shouldn't
              // clear the selection, since this field always needs one.
              event.preventDefault();
              return;
            }

            event.preventDefault();
            suppress = true;

            checkboxes.forEach(function (other) {
              if (other !== checkbox && other.checked) {
                other.click();
              }
            });

            checkbox.click();

            suppress = false;
          });
        }

        checkbox.dataset.foiluxHeartAdded = 'true';
      });
    }

    function tryEnhance() {
      var container = document.querySelector('.foilux-social-permissions');
      if (!container) return;

      try {
        enhance(container);
      } catch (error) {
        /* Fails safe: native Infinite Options field remains fully usable. */
      }
    }

    try {
      var observer = new MutationObserver(tryEnhance);
      observer.observe(document.body, { childList: true, subtree: true });
      tryEnhance();
    } catch (error) {
      /* Fails safe: native Infinite Options field remains fully usable. */
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
